var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_647_25356)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.1371,
    cy: 23.6974,
    r: 19.2722,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7218 24.8136L25.5597 27.5766M25.5526 19.9541L20.7218 22.7171M29.5122 18.9059C29.5122 20.0561 28.5608 20.9885 27.3872 20.9885C26.2136 20.9885 25.2622 20.0561 25.2622 18.9059C25.2622 17.7557 26.2136 16.8232 27.3872 16.8232C28.5608 16.8232 29.5122 17.7557 29.5122 18.9059ZM21.0122 23.7654C21.0122 24.9156 20.0608 25.848 18.8872 25.848C17.7136 25.848 16.7622 24.9156 16.7622 23.7654C16.7622 22.6152 17.7136 21.6827 18.8872 21.6827C20.0608 21.6827 21.0122 22.6152 21.0122 23.7654ZM29.5122 28.6249C29.5122 29.7751 28.5608 30.7075 27.3872 30.7075C26.2136 30.7075 25.2622 29.7751 25.2622 28.6249C25.2622 27.4746 26.2136 26.5422 27.3872 26.5422C28.5608 26.5422 29.5122 27.4746 29.5122 28.6249Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_647_25356",
    x: 0.86499,
    y: 0.425293,
    width: 46.5443,
    height: 46.5443,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.996208 0 0 0 0 0.996208 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_647_25356"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_647_25356",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.f0803629812aa0c2a927bb49151e17d5.svg";
export { ForwardRef as ReactComponent };